// extracted by mini-css-extract-plugin
export default {"un-auth-container":"Unauthorized_un-auth-container__IKx6q","auth":"Unauthorized_auth__SoxYb"};